export default __webpack_public_path__ + "static/media/8.d473858e.mp4";